import React, { useEffect, useState } from "react";
import Input from "../../../CoreComponent/Input";
import Checkbox from "../../../CoreComponent/Checkbox/index";
import DateInput from "../../../CoreComponent/Date";
import toast from "react-hot-toast";
import { useStepper } from "../StepperContext";
import "./style.scss";
import Select from "../../../CoreComponent/Select";
import { Button, Grid } from "@mui/material";
import axios from "axios";
import { useAuth } from "../../../common/AuthContext";

const ReservationForm = () => {
  const {
    currentStep,
    completeStep,

    roomType,
    setRoomType,

    checkInDate,
    setCheckInDate,

    checkOutDate,
    setCheckOutDate,

    lateCheckOut,
    setLateCheckOut,

    earlyCheckIn,
    setEarlyCheckIn,

    totalNights,
    setTotalNights,
  } = useStepper();

  const { myConferenceId } = useAuth();
  const [hotel, setHotel] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ROOM TYPE OPTIONS
  const options = [
    { value: "Single", label: "Single" },
    { value: "Double", label: "Double" },
    { value: "Triple", label: "Triple" },
  ];

  const BaseUrl = process.env.REACT_APP_BASE_URL;

  // ---------------------------------------------------
  // CREATE PROPER LOCAL DATE-TIME FORMAT (Important!!)
  // ---------------------------------------------------
  const getLocalDateTime = (date = new Date()) => {
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return date.toISOString().slice(0, 16);  // YYYY-MM-DDTHH:MM
  };

  const todayDateTime = getLocalDateTime(); // Prevent past

  // ---------------------------------------------------
  // CHECK-IN logic — ensures checkout always > checkin
  // ---------------------------------------------------
  const handleCheckInChange = (val) => {
    setCheckInDate(val);

    if (!checkOutDate || checkOutDate <= val) {
      const newOut = new Date(val);
      newOut.setHours(newOut.getHours() + 1); // Minimum 1 hour later

      setCheckOutDate(getLocalDateTime(newOut));
    }
  };

  // ---------------------------------------------------
  // LOAD HOTEL DATA
  // ---------------------------------------------------
  const getPricesRoom = async () => {
    const token = localStorage.getItem("token");

    try {
      setLoading(true);
      const res = await axios.get(
        `${BaseUrl}/room-prices/${myConferenceId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setLoading(false);
      setHotel(res.data.data.hotel_name);

    } catch (err) {
      setLoading(false);
      setError("Failed to load room prices.");
    }
  };

  useEffect(() => {
    getPricesRoom();
  }, [myConferenceId]);


  // ---------------------------------------------------
  // FORM SUBMIT
  // ---------------------------------------------------
  const handleSubmit = () => {
    toast.success("The data was updated successfully!");
    completeStep(currentStep);
  };

  // ---------------------------------------------------
  // RENDER UI
  // ---------------------------------------------------

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <>
      <form>
        <div className="hotel-name-container">
          {hotel ? <span className="hotel-name">{hotel}</span> : "Loading hotel..."}
        </div>

        <Grid container spacing={2}>

          {/* ROOM TYPE */}
          <Grid item xs={12}>
            <Select
              options={options}
              value={roomType}
              setValue={setRoomType}
              label="Room Type"
              required={true}
            />
          </Grid>

          {/* CHECK-IN */}
          <Grid item xs={12}>
            <DateInput
              label="Check In Date"
              type="datetime-local"
              inputValue={checkInDate}
              setInputValue={handleCheckInChange}
              minDate={todayDateTime}      // <-- BLOCK PAST
            />
          </Grid>

          {/* CHECK-OUT */}
          <Grid item xs={12}>
            <DateInput
              label="Check Out Date"
              type="datetime-local"
              inputValue={checkOutDate}
              setInputValue={setCheckOutDate}
              minDate={checkInDate || todayDateTime}   // <-- MUST be after check-in
            />
          </Grid>

          {/* EARLY CHECK-IN */}
          <Grid item xs={12} sm={6}>
            <Checkbox
              label="Early Check In?"
              checkboxValue={earlyCheckIn}
              setCheckboxValue={setEarlyCheckIn}
            />
          </Grid>

          {/* LATE CHECKOUT */}
          <Grid item xs={12} sm={6}>
            <Checkbox
              label="Late Check Out?"
              checkboxValue={lateCheckOut}
              setCheckboxValue={setLateCheckOut}
            />
          </Grid>

          {/* TOTAL NIGHTS */}
          <Grid item xs={12}>
            <Input
              label="Total Nights"
              type="number"
              inputValue={totalNights}
              setInputValue={setTotalNights}
              placeholder="Enter total nights"
            />
          </Grid>

        </Grid>
      </form>

      {/* NEXT BUTTON */}
      <div className="actions-section">
        <Button
          className={`next-button ${
            !checkInDate || !checkOutDate || !totalNights || !roomType
              ? "disabled"
              : ""
          }`}
          variant="contained"
          sx={{
            backgroundColor: "#c62828",
            marginTop: "20px",
            color: "#fff",
            width: "100%",
            "&:hover": {
              backgroundColor: "#e63946",
              color: "#fff",
            },
          }}
          onClick={handleSubmit}
          disabled={!checkInDate || !checkOutDate || !totalNights || !roomType}
        >
          Next
        </Button>
      </div>
    </>
  );
};

export default ReservationForm;